// extracted by mini-css-extract-plugin
export default {"footerButtonContainer":"footerButtonContainer__2t2K5"};
    if(module.hot) {
      // 1778491687932
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  